import _ from 'lodash';
export const scoreStandardList = [
  {
    seqNum: 1,
    questionSetSeqNum: 1,
    questionType: 'Radio selection(Single)',
    content: '',
    optionScore:
      '[{"option": "1", "score": 1},{"option": "2", "score": 1},{"option": "3", "score": 3},{"option": "4", "score": 5}]',
  },
  {
    seqNum: 2,
    questionSetSeqNum: 1,
    questionType: 'Radio selection(Single)',
    content: '',
    optionScore:
      '[{"option": "1", "score": null}, {"option": "2", "score": 5}, {"option": "3", "score": 3}]',
  },
  {
    seqNum: 3,
    questionSetSeqNum: 1,
    questionType: 'Radio selection(Single)',
    content: '',
    optionScore: '[{"option": "1", "score": 5}, {"option": "2", "score": 3}]',
  },
  {
    seqNum: 4,
    questionSetSeqNum: 1,
    questionType: 'Radio selection(Single)',
    content: '',
    optionScore:
      '[{"option": "1", "score": 1}, {"option": "2", "score": 1}, {"option": "3", "score": 3}, {"option": "4", "score": 5}, {"option": "5", "score": 5}]',
  },
  {
    seqNum: 5,
    questionSetSeqNum: 1,
    questionType: 'Radio selection(Single)',
    content: '',
    optionScore:
      '[{"option": "1", "score": 1}, {"option": "2", "score": 3}, {"option": "3", "score": 5}]',
  },
  {
    seqNum: 6,
    questionSetSeqNum: 1,
    questionType: 'Radio selection(Single)',
    content: '',
    optionScore:
      '[{"option": "1", "score": 1}, {"option": "2", "score": 3}, {"option": "3", "score": 5}]',
  },
  {
    seqNum: 7,
    questionSetSeqNum: 1,
    questionType: 'Radio selection(Single)',
    content: '',
    optionScore:
      '[{"option": "1", "score": 5}, {"option": "2", "score": 5}, {"option": "3", "score": 3}, {"option": "4", "score": 1}, {"option": "5", "score": 1}]',
  },
  {
    seqNum: 8,
    questionSetSeqNum: 2,
    questionType: 'Radio selection(Single)',
    content: '',
    optionScore:
      '[{"option": "1", "score": 1}, {"option": "2", "score": 3}, {"option": "3", "score": 5}]',
  },
  {
    seqNum: 9,
    questionSetSeqNum: 2,
    questionType: 'Radio selection(Single)',
    content: '',
    optionScore:
      '[{"option": "1", "score": 1}, {"option": "2", "score": 1}, {"option": "3", "score": 3}, {"option": "4", "score": 5}, {"option": "5", "score": 5}]',
  },
  {
    seqNum: 10,
    questionSetSeqNum: 2,
    questionType: 'Radio selection(Single)',
    content: '',
    optionScore:
      '[{"option": "1", "score": 1}, {"option": "2", "score": 3}, {"option": "3", "score": 5}]',
  },
  {
    seqNum: 11,
    questionSetSeqNum: 3,
    questionType: 'Multiple Choice Grid',
    content: '',
    optionScore: '',
  },
  {
    seqNum: 12,
    questionSetSeqNum: 3,
    questionType: 'Radio selection(Single)',
    content: '',
    optionScore:
      '[{"option": "1", "score": 5}, {"option": "2", "score": 5}, {"option": "3", "score": 3}, {"option": "4", "score": 1}, {"option": "5", "score": 1}]',
  },
  {
    seqNum: 13,
    questionSetSeqNum: 3,
    questionType: 'Radio selection(Single)',
    content: '',
    optionScore:
      '[{"option": "1", "score": 5}, {"option": "2", "score": 5}, {"option": "3", "score": 3}, {"option": "4", "score": 1}, {"option": "5", "score": 1}]',
  },
];

export const levelScore = {
  high: 3,
  medium: 2,
  low: 1,
};
export function calculateScore(item) {
  let buyerERPVendor = null;
  let targetERPVendor = null;

  let itemScore = null;

  if (item.type === 'execution') {
    const answer = item.answer;
    if (item.sequenceNumber === 32) {
      buyerERPVendor = answer.buyer.vendor;
      targetERPVendor = answer.target.vendor;

      if (buyerERPVendor === 'Other' || targetERPVendor === 'Other') {
        itemScore = 5;
      } else if (
        answer.buyer.noApplication === true &&
        answer.target.noApplication === true
      ) {
        itemScore = 1;
      } else if (
        answer.buyer.noApplication !== true &&
        answer.target.noApplication !== true &&
        buyerERPVendor === targetERPVendor &&
        answer.buyer.version === answer.target.version
      ) {
        itemScore = 1;
      } else {
        if (
          answer.buyer.noApplication === true ||
          answer.target.noApplication === true
        ) {
          itemScore = 3;
        } else {
          itemScore = 5;
        }
      }
    } else if (item.sequenceNumber === 33 || item.sequenceNumber === 34) {
      let buyerApplication = answer.buyer.application;
      let targetApplication = answer.target.application;
      if (buyerApplication === 'Same vendor as ERP') {
        buyerApplication = buyerERPVendor;
      }
      if (targetApplication === 'Same vendor as ERP') {
        targetApplication = targetERPVendor;
      }

      if (buyerApplication === 'Other' || targetApplication === 'Other') {
        itemScore = 5;
      } else if (
        (answer.buyer.noApplication !== true &&
          answer.target.noApplication !== true &&
          buyerApplication === targetApplication) ||
        (answer.buyer.noApplication === true &&
          answer.target.noApplication === true)
      ) {
        itemScore = 1;
      } else {
        if (
          answer.buyer.noApplication === true ||
          answer.target.noApplication === true
        ) {
          itemScore = 3;
        } else {
          itemScore = 5;
        }
      }
    } else if (item.sequenceNumber === 35 || item.sequenceNumber === 36) {
      const buyerApplication = answer.buyer.application;
      const buyerVendor = answer.buyer.vendor;
      const targetApplication = answer.target.application;
      const targetVendor = answer.target.vendor;

      if (
        (answer.buyer.noApplication !== true &&
          answer.target.noApplication !== true &&
          buyerApplication === targetApplication &&
          buyerVendor === targetVendor) ||
        (answer.buyer.noApplication === true &&
          answer.target.noApplication === true)
      ) {
        itemScore = 1;
      } else {
        if (
          answer.buyer.noApplication === true ||
          answer.target.noApplication === true
        ) {
          itemScore = 3;
        } else {
          itemScore = 5;
        }
      }
    } else {
      const scoreStandard = _.chain(scoreStandardList)
        .filter((o) => o.seqNum === item.sequenceNumber)
        .value()[0];
      const scoreObj = _.chain(JSON.parse(scoreStandard.optionScore))
        .filter((s) => s.option === item.answer)
        .value()[0];
      itemScore = scoreObj.score;
    }
  } else if (item.type === 'multiRadio') {
    itemScore = (item.answer || []).reduce((acc, e, i) => {
      const res = e === '1' ? acc + 1 : acc;
      if (i !== 4) {
        return res;
      }
      return res > 2 ? 1 : res < 2 ? 5 : 3;
    }, 0);
  } else if (item.type === 'checkbox') {
    if (item.answer.length > 3) {
      itemScore = 1;
    } else if (item.answer.length > 0 && item.answer.length <= 3) {
      itemScore = 5;
    }
  } else {
    const scoreStandard = _.chain(scoreStandardList)
      .filter((o) => o.seqNum === item.sequenceNumber)
      .value()[0];
    const scoreObj = _.chain(JSON.parse(scoreStandard.optionScore))
      .filter((s) => s.option === item.answer)
      .value()[0];
    itemScore = scoreObj?.score;
  }
  console.log({ itemScore });
  return itemScore;
}

export function calculateSectionScore(modelsData) {
  console.log(modelsData);
  const res = modelsData.reduce((result, item, idx, self) => {
    if (idx === 1 && item.score === null) {
      return result + self[0].score;
    }
    return item.score + result;
  }, 0);
  const score = res / (modelsData.length * 5);
  console.log({ score });
  if (score <= 0.4) {
    return 'low';
  } else if (score > 0.4 && score <= 0.75) {
    return 'medium';
  }
  return 'high';
}
